import { P } from '@angular/cdk/keycodes';
import { Permissions } from './permissions.enum';

export enum UserRole {
  DOCTOR = 'DOCTOR',
  RECEPTION = 'RECEPTION',
  MANAGER = 'MANAGER',
}

export const UserRolePermissions: Record<UserRole, Permissions[]> = {
  // [UserRole.PATIENT]: [Permissions.PATIENT],
  [UserRole.DOCTOR]: [
    Permissions.SCHEDULING,
    Permissions.UPDATING_APPOINTMENTS,
    Permissions.VIEW_PATIENT_NOTES,
    Permissions.VIEW_PATIENTS,
    Permissions.PATIENT_CONFIDENTIAL_HEALTH_DETAILS,
    Permissions.DOCTOR,
  ],
  [UserRole.RECEPTION]: [
    Permissions.SCHEDULING,
    Permissions.UPDATING_APPOINTMENTS,
    Permissions.VIEW_PATIENTS,
    Permissions.RECEPTION,
  ],
  [UserRole.MANAGER]: [
    Permissions.USER_ONBOARDING,
    Permissions.BILLING,
    Permissions.SCHEDULING,

    Permissions.VIEW_PATIENTS,
    Permissions.MANAGER,
  ],
};
